import React from "react";
import styles from './style';
import { withStyles } from '@material-ui/core';
import MobilePreview from "storybookComponents/MobilePreview";
import SwipeableViews from "react-swipeable-views";
import { htmls } from "./htmls";
import portalCode from "content/Campgain/OmnichannelPreview/components/residentialPortal/embeded-code"
import enrollCode from "content/Campgain/OmnichannelPreview/components/enrollForm/embeded-code"
import shareCode from "content/Campgain/OmnichannelPreview/components/sharePreview/embeded-code"
import thankyouCode from "content/Campgain/OmnichannelPreview/components/sharePreview/thanks-popup-embed-code"
import { smsPreviewHtml } from "content/Campgain/OmnichannelPreview/utils/index";
var that;
class LivePreview extends React.PureComponent {

  constructor(p) {
    super(p);
    that = this;
  }



  update = (props) => {
    const { ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12 } = that;
    if (ref1)
      ref1.updateHtml(htmls.email(props).replace(/\%reward\%/g, "$" + props.reward));
    if (ref2)
      ref2.updateHtml(portalCode(props, true).replace(/\%reward\%/g, "$" + props.reward))
    if (ref3)
      ref3.updateHtml(enrollCode(props).replace(/\%reward\%/g, "$" + props.reward))
    if (ref4)
      ref4.updateHtml(htmls.thankYouEmail(props).replace(/\%reward\%/g, "$" + props.reward))
    if (ref5)
      ref5.updateHtml(shareCode(props).replace(/\%reward\%/g, "$" + props.reward))
    if (ref6)
      ref6.updateHtml(htmls.residentInvite(props).replace(/\%reward\%/g, "$" + props.reward))
    if (ref7)
      ref7.updateHtml(thankyouCode(props.reward, props.tourCtaUrl, props).replace(/\%reward\%/g, "$" + props.reward))
    if (ref8)
      ref8.updateHtml(htmls.residentInvite(props).replace(/\%reward\%/g, "$" + props.reward))
    if (ref9)
      ref9.updateHtml(htmls.residentReward(props).replace(/\%reward\%/g, "$" + props.reward))
    if (ref10)
      ref10.updateHtml(
        smsPreviewHtml(
          props.image,
          `<div style="font-size:18px;">${props.emailSms.replace(
            /\%reward\%/g,
            "$" + props.reward
          )}<br> <br><b>Enroll Now,</b><br>
        ${!props.shortEnrollUrl
            ? `<span style="opacity:0.5">
        URL appears here once referral campaign is created</span>`
            : `<a href=${props.shortEnrollUrl}>${props.shortEnrollUrl}</a>`
          }<br><br>Best Regards<br><div style='margin-top:10px;'><b>${props.property.name
          }</b></div></div>`,
          props.orgColors.linkColor
        )
      );
    if (ref11)
      ref11.updateHtml(
        smsPreviewHtml(
          props.residentDiscountImage,
          `<div style="font-size:18px;">${props.residentDiscountEmailSms.replace(
            /\%reward\%/g,
            "$" + props.reward
          )}<br> <br><b>Refer Again,</b><br>
        ${!props.shortEnrollUrl
            ? `<span style="opacity:0.5">
        URL appears here once referral campaign is created</span>`
            : `<a href=${props.shortEnrollUrl}>${props.shortEnrollUrl}</a>`
          }<br><br>Best Regards<br><div style='margin-top:10px;'><b>${props.property.name
          }</b></div></div>`,
          props.orgColors.linkColor
        )
      );
    if (ref12)
      ref12.updateHtml(htmls.residentInvite({
        ...props,
        friendInviteEmailHeader: null,
        residentInviteEmailSubject: null,
        residentInviteEmailBody: props.landingPageContent,
        residentInviteImage: props.landingPageImage,
        subtitle: props.landingPageTitle
      }))
  }

  setRef = (key, ref) => {
    that[key] = ref;
  }

  render() {
    const { classes, index } = this.props;
    const html = {
      email: htmls.email(this.props).replace(/\%reward\%/g, "$" + this.props.reward),
      portal: portalCode(this.props, true).replace(/\%reward\%/g, "$" + this.props.reward),
      friendEmail: htmls.residentInvite(this.props).replace(/\%reward\%/g, "$" + this.props.reward),
      discountEmail: htmls.residentReward(this.props).replace(/\%reward\%/g, "$" + this.props.reward),
      enroll: enrollCode(this.props).replace(/\%reward\%/g, "$" + this.props.reward),
      share: shareCode(this.props).replace(/\%reward\%/g, "$" + this.props.reward),
      thankyou: thankyouCode(this.props.reward, this.props.tourCtaUrl, this.props).replace(/\%reward\%/g, "$" + this.props.reward),
      thankyouEmail: htmls.thankYouEmail(this.props).replace(/\%reward\%/g, "$" + this.props.reward),
      smsInviteResidents: smsPreviewHtml(
        this.props.image,
        `<div style="font-size:18px;">${this.props.emailSms.replace(
          /\%reward\%/g,
          "$" + this.props.reward
        )}<br> <br><b>Enroll Now,</b><br>
        ${!this.props.shortEnrollUrl
          ? `<span style="opacity:0.5">
        URL appears here once referral campaign is created</span>`
          : `<a href=${this.props.shortEnrollUrl}>${this.props.shortEnrollUrl}</a>`
        }<br><br>Best Regards<br><div style='margin-top:10px;'><b>${this.props.property.name
        }</b></div></div>`,
        this.props.orgColors.linkColor
      ),
      smsResidentDiscount: smsPreviewHtml(
        this.props.residentDiscountImage,
        `<div style="font-size:18px;">${this.props.residentDiscountEmailSms.replace(
          /\%reward\%/g,
          "$" + this.props.reward
        )}<br> <br><b>Refer Again,</b><br>
        ${!this.props.shortEnrollUrl
          ? `<span style="opacity:0.5">
        URL appears here once referral campaign is created</span>`
          : `<a href=${this.props.shortEnrollUrl}>${this.props.shortEnrollUrl}</a>`
        }<br><br>Best Regards<br><div style='margin-top:10px;'><b>${this.props.property.name
        }</b></div></div>`,
        this.props.orgColors.linkColor
      ),
      landingPageHtml: htmls.residentInvite({
        ...this.props,
        friendInviteEmailHeader: null,
        residentInviteEmailSubject: null,
        residentInviteEmailBody: this.props.landingPageContent,
        residentInviteImage: this.props.landingPageImage,
        subtitle: this.props.landingPageTitle
      })
    }

    const height = null//window.innerHeight - 150;
    const width = null

    return (
      <div className={classes.previewContainer}>
        <SwipeableViews index={index} animateTransitions={false} className="swipeable-view">
          <MobilePreview ref={this.setRef.bind(this, "ref1")} id="live1" html={html.email} height={height} width={width} />
          <MobilePreview ref={this.setRef.bind(this, "ref2")} id="live2" html={html.portal} height={height} width={width} />
          <MobilePreview ref={this.setRef.bind(this, "ref3")} id="live3" html={html.enroll} mainBg="rgb(255 255 255)" height={height} width={width} />
          <MobilePreview ref={this.setRef.bind(this, "ref4")} id="live4" html={html.thankyouEmail} height={height} width={width} />
          <MobilePreview ref={this.setRef.bind(this, "ref5")} id="live5" html={html.share} customHeight={750} mainBg="rgb(255 255 255)" height={height} width={width} />
          <MobilePreview ref={this.setRef.bind(this, "ref6")} id="live6" html={html.friendEmail} height={height} width={width} />
          <MobilePreview ref={this.setRef.bind(this, "ref7")} id="live7" html={html.thankyou} customHeight={750} mainBg="rgb(255 255 255)" height={height} width={width} />
          <MobilePreview ref={this.setRef.bind(this, "ref8")} html={html.friendEmail} scrollToBottom height={height} width={width} />
          <MobilePreview ref={this.setRef.bind(this, "ref9")} html={html.discountEmail} height={height} width={width} />
          <MobilePreview
            ref={this.setRef.bind(this, "ref10")}
            id="live10"
            html={html.smsInviteResidents}
            // height={height}
            // width={width}
            smsView
          />
          <MobilePreview
            ref={this.setRef.bind(this, "ref11")}
            id="live11"
            html={html.smsResidentDiscount}
            // height={height}
            // width={width}
            smsView
          />
          <MobilePreview
            ref={this.setRef.bind(this, "ref12")}
            id="live12"
            html={html.friendEmail}
            height={height}
            width={width}
          />
          <div />
        </SwipeableViews>
      </div>
    )
  }
}

export default withStyles(styles)(LivePreview);